import { format } from 'date-fns';
import { LocallyStoredRegistrationData } from '../../models/registered-item/locally-stored-registration-data.interface';

export const mockLocallyStoredRegistrationData: LocallyStoredRegistrationData =
  {
    brand: 'AEG',
    modelNumber: '123',
    purchaseDate: format(new Date(), 'yyyy-MM-dd'),
    purchasePrice: '300',
    serialNumber: '456',
    type: 'CN',
  };
